import Http from "@/commons/Http.js";

const path = 'api/v2/regras-estaduais/RS';

export default  {

  async getValoresPosteriorAto(ato){
    return Http.get(`${path}/valores-posterior/${ato}`);
  },

  async getValoresPosteriorCertidao(certidao){
    return Http.get(`${path}/valores-posterior-certidao/${certidao}`);
  },

  async importarRetorno(file){
    const formData = new FormData();
    formData.append("file", file);

    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    return Http.post(`${path}/importar-retorno`, formData, config);
  },
}
